"use client";
import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { memo as n, forwardRef as a } from "react";
import { useSvgIcon as p } from "../useSvgIcon.js";
const i = n(
  a((r, t) => {
    const { monochrome: m, ...e } = r, s = p({
      ...e,
      ref: t
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 512.000000 512.000000",
        preserveAspectRatio: "xMidYMid meet",
        ...s(),
        children: /* @__PURE__ */ c(
          "g",
          {
            transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
            fill: "var(--icon-color)",
            stroke: "none",
            children: [
              /* @__PURE__ */ o("path", { d: "M1340 5114 c-14 -3 -89 -14 -166 -25 -189 -26 -267 -49 -409 -118 -265 -130 -481 -343 -612 -606 -76 -151 -108 -278 -144 -578 -13 -113 -6 -156 38 -208 33 -38 95 -69 143 -69 78 0 159 63 180 138 5 20 19 107 30 192 11 85 30 186 41 225 81 271 315 512 589 607 54 19 234 50 360 63 36 4 81 14 100 22 143 59 161 245 32 334 -34 23 -119 34 -182 23z" }),
              /* @__PURE__ */ o("path", { d: "M3625 5102 c-139 -65 -155 -245 -29 -331 25 -17 65 -27 178 -42 80 -11 179 -26 220 -33 329 -63 640 -376 702 -705 8 -42 23 -140 33 -219 15 -111 24 -150 41 -176 67 -96 197 -115 280 -40 53 48 74 107 66 181 -20 176 -51 356 -72 432 -56 190 -160 365 -316 526 -115 120 -235 208 -373 276 -126 61 -234 92 -411 118 -223 33 -272 35 -319 13z" }),
              /* @__PURE__ */ o("path", { d: "M2396 4044 c-257 -57 -455 -236 -543 -489 -25 -73 -27 -93 -27 -220 0 -123 3 -149 26 -217 41 -123 92 -204 187 -298 150 -149 325 -217 535 -208 197 9 341 73 481 213 92 92 144 176 182 290 23 69 26 98 27 210 1 148 -14 216 -70 330 -88 181 -265 327 -459 380 -88 24 -254 28 -339 9z" }),
              /* @__PURE__ */ o("path", { d: "M1929 2419 c-245 -11 -325 -37 -435 -141 -98 -93 -131 -188 -140 -403 -11 -256 16 -409 92 -523 75 -114 178 -189 305 -221 137 -35 554 -71 819 -71 280 0 705 40 828 79 167 51 305 205 348 388 20 83 24 416 6 508 -36 180 -174 326 -346 365 -122 27 -1038 39 -1477 19z" }),
              /* @__PURE__ */ o("path", { d: "M115 1597 c-46 -21 -94 -76 -106 -121 -12 -44 -9 -87 22 -300 47 -321 149 -533 361 -752 211 -217 435 -336 724 -383 313 -52 371 -50 435 13 62 60 76 144 38 224 -36 72 -75 91 -241 113 -210 27 -287 44 -370 78 -253 106 -478 357 -543 608 -8 31 -26 138 -40 237 -27 196 -37 222 -103 266 -41 29 -132 37 -177 17z" }),
              /* @__PURE__ */ o("path", { d: "M4855 1591 c-50 -22 -91 -69 -105 -119 -5 -20 -19 -105 -30 -188 -24 -183 -40 -247 -85 -341 -112 -238 -326 -427 -569 -502 -38 -12 -148 -32 -246 -45 -98 -13 -191 -31 -207 -40 -137 -70 -136 -269 2 -336 54 -26 100 -25 335 10 180 27 264 51 395 114 178 86 316 191 434 331 173 204 259 388 300 640 37 224 45 313 32 355 -33 111 -154 168 -256 121z" })
            ]
          }
        )
      }
    );
  })
);
i.displayName = "IconPasskey";
export {
  i as IconPasskey
};
